import { Link } from "react-router-dom";
import { MapPin, Wrench, ChevronRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { CITIES, SERVICE_LINKS } from "@/seo/seoConfig";
import { LABELS } from "@/seo/seoLabels";

const serif = { fontFamily: "'Playfair Display', serif" };

const LocalLinksSection = () => {
  const { language: lang } = useLanguage();
  const L = LABELS[lang];
  return (
    <section id="areas" className="py-12 md:py-20 bg-slate-50" data-testid="local-links-section">
      <div className="px-4 md:px-8 lg:px-16 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
        <div>
          <p className="text-xs md:text-sm text-[#D4AF37] uppercase tracking-widest mb-2 font-semibold flex items-center gap-2"><Wrench className="w-4 h-4" />{L.services}</p>
          <h2 className="text-2xl md:text-3xl font-bold text-[#0F172A] mb-6" style={serif}>
            {lang === "en" ? "Plumbing Services We Provide" : "Servicios de Plomería que Ofrecemos"}
          </h2>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {SERVICE_LINKS.map((s) => (
              <li key={s.slug}>
                <Link to={`/${s.slug}`} className="group flex items-center justify-between bg-white border border-slate-200 px-4 py-3 text-sm text-[#0F172A] hover:border-[#D4AF37] hover:text-[#B5952F] transition-colors duration-300" data-testid={`home-service-link-${s.slug}`}>
                  {s[lang]} <ChevronRight className="w-4 h-4 text-[#D4AF37] group-hover:translate-x-1 transition-transform" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs md:text-sm text-[#D4AF37] uppercase tracking-widest mb-2 font-semibold flex items-center gap-2"><MapPin className="w-4 h-4" />{L.serviceAreas}</p>
          <h2 className="text-2xl md:text-3xl font-bold text-[#0F172A] mb-6" style={serif}>
            {lang === "en" ? "Serving Hampton Roads, Virginia" : "Atendemos Hampton Roads, Virginia"}
          </h2>
          <p className="text-slate-600 text-sm md:text-base mb-5">
            {lang === "en"
              ? "Residential and light commercial plumbing across the Southside and the Peninsula. Choose your city to learn more."
              : "Plomería residencial y comercial ligera en el Southside y la Península. Elija su ciudad para saber más."}
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/${c.slug}`} className="group flex items-center justify-between bg-white border border-slate-200 px-4 py-3 text-sm text-[#0F172A] hover:border-[#D4AF37] hover:text-[#B5952F] transition-colors duration-300" data-testid={`home-city-link-${c.slug}`}>
                  {lang === "en" ? `Plumber in ${c.name}, VA` : `Plomero en ${c.name}, VA`} <ChevronRight className="w-4 h-4 text-[#D4AF37] group-hover:translate-x-1 transition-transform" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default LocalLinksSection;
